module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "easy-week-component"
  }, [_c('div', {
    staticClass: "grid-container",
    style: (_vm.gridCss)
  }, [_c('div', {
    staticClass: "grid-row-header grid-column-header plate"
  }, [_c('span', [_vm._v(_vm._s(_vm.plate))])]), _vm._l((_vm.shifts), function(shift) {
    return _c('div', {
      staticClass: "grid-column-header shift-header",
      style: ({
        'grid-row': shift.name + shift.id
      })
    }, [_c('b', [_vm._v(_vm._s(shift.name))]), _c('span', [_vm._v(_vm._s(shift.start))]), _c('span', [_vm._v(_vm._s(shift.end))])])
  }), _vm._l((_vm.doDays), function(dayShift, idx) {
    return [_c('div', {
      staticClass: "grid-row-header"
    }, [_c('span', [_vm._v(_vm._s(dayShift.name) + " " + _vm._s(dayShift.date))])]), _vm._l((dayShift.shifts), function(shift) {
      return _c('div', {
        staticClass: "bracket",
        style: ({
          'grid-row': shift.name + shift.id,
          'grid-column': idx + 2,
          'background-color': _vm.getBackgroundColor(shift)
        })
      }, [(shift.reservations.length) ? _c('div', {
        staticClass: "bracket-reservations"
      }, _vm._l((shift.reservations), function(res) {
        return _c('div', {
          key: res.reservation_id,
          staticClass: "bracket-reservation",
          class: res.status.toLowerCase(),
          style: ({
            'background-color': dayShift.color || _vm.getColor(res, shift) || '#fafafa'
          })
        }, [_c('p', {
          on: {
            "click": function($event) {
              return _vm.getDetails(res)
            }
          }
        }, [(_vm.daysToShow <= 21) ? [_c('router-link', {
          attrs: {
            "to": {
              name: 'driver',
              params: {
                id: res.driver_id
              }
            }
          }
        }, [_c('b', [_vm._v("DR" + _vm._s(res.driver_id))])]), _c('br'), _c('router-link', {
          attrs: {
            "to": {
              name: 'reservation',
              params: {
                id: res.reservation_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "reservation-id"
        }, [_vm._v("R" + _vm._s(res.reservation_id))])])] : _vm._e()], 2)])
      }), 0) : _vm._e()])
    })]
  })], 2), (_vm.details || _vm.loadingDetails) ? _c('div', {
    staticClass: "details-container"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close alert",
      "type": "button"
    },
    on: {
      "click": _vm.clearDetails
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), (_vm.loadingDetails) ? _c('LoadingSpinner') : (_vm.details) ? _c('div', {
    staticClass: "row"
  }, [(_vm.details.reservation) ? _c('div', {
    staticClass: "columns small-12"
  }, [_c('h4', [_vm._v("reservation details")]), _c('Reservation', {
    attrs: {
      "type": "listing",
      "item": _vm.details.reservation
    }
  })], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04e5920d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/EasyWeek.vue
// module id = 2102
// module chunks = 1